import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import inflection from 'inflection';
import compose from 'recompose/compose';
import { withStyles } from '@material-ui/core/styles';
import classnames from 'classnames';
import { getResources, translate } from 'react-admin';
import DefaultIcon from '@material-ui/icons/ViewList';
import negate from 'lodash/fp/negate';
import {ExpansionPanel,ExpansionPanelSummary, ExpansionPanelDetails} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import {DashboardMenuItem, MenuItemLink, Responsive} from 'react-admin';

const styles = {
    main: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
    },
    accordion: {
        backgroundColor: 'transparent'
    },
    nopadding: {
        padding:0
    }
};


const translatedResourceName = ({options, name}) =>
    options && options.label
        ? options.label
        : inflection.humanize(inflection.pluralize(name));

const renderLink = ({onMenuClick, dense}) => resource => (
    <MenuItemLink
        key={resource.name}
        to={`/${resource.name}`}
        primaryText={translatedResourceName(resource)}
        leftIcon={
            resource.icon ? <resource.icon /> : <DefaultIcon />
        }
        onClick={onMenuClick}
        dense={dense}
    />
);
const topLevel = (r) => r.name.indexOf('/') === -1;
const noop = (e) => e && e.preventDefault();

const MenuComponent = ({
                  classes,
                  className,
                  dense,
                  hasDashboard,
                  onMenuClick,
                  open,
                  pathname,
                  resources,
                  translate,
                  logout,
                  ...rest
              }) => {
    const menuItemLink = renderLink({onMenuClick, dense});

    return (
        <div className={classnames(classes.main, className)} {...rest}>
        {hasDashboard && <DashboardMenuItem onClick={onMenuClick}/>}
        {
            resources
                .filter(r => r.hasList)
                .filter(topLevel)
                .map(menuItemLink)
        }

        <ExpansionPanel className={classnames(classes.accordion)} >
            <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />} className={classnames(classes.nopadding)}>
                <MenuItemLink key={'unpub-accordion'}
                    primaryText={"Unpublished"}
                    leftIcon={<DefaultIcon/>}
                    onClick={noop}
                    dense={dense}
                    to={'#'}
                > Unpublished Movies </MenuItemLink>
            </ExpansionPanelSummary>
            <ExpansionPanelDetails className={classnames(classes.main, classes.nopadding)}>
                {
                    resources.filter(r => r.hasList)
                        .filter(negate(topLevel))
                        .map(menuItemLink)
                }
            </ExpansionPanelDetails>

        </ExpansionPanel>
        <Responsive xsmall={logout} medium={null}/>
    </div>
    );
};

MenuComponent.propTypes = {
    classes: PropTypes.object,
    className: PropTypes.string,
    dense: PropTypes.bool,
    hasDashboard: PropTypes.bool,
    logout: PropTypes.element,
    onMenuClick: PropTypes.func,
    open: PropTypes.bool,
    pathname: PropTypes.string,
    resources: PropTypes.array.isRequired,
    translate: PropTypes.func.isRequired,
};

MenuComponent.defaultProps = {
    onMenuClick: () => null,
};


const mapStateToProps = state => ({
    open: state.admin.ui.sidebarOpen,
    resources: getResources(state),
    pathname: state.router.location.pathname, // used to force redraw on navigation
});

const enhance = compose(
    translate,
    connect(
        mapStateToProps,
        {}, // Avoid connect passing dispatch in props,
        null,
        {
            areStatePropsEqual: (prev, next) =>
                prev.resources.every(
                    (value, index) => value === next.resources[index] // shallow compare resources
                ) &&
                // eslint-disable-next-line eqeqeq
                prev.pathname == next.pathname &&
                // eslint-disable-next-line eqeqeq
                prev.open == next.open,
        }
    ),
    withStyles(styles)
);

export const Menu = enhance(MenuComponent);
